<ideal-product-section
  i18n-title="@@products.specifications.label"
  title="Specifications"
  navAnchorId="app.main-menu/products/details/specifications"
  navAnchorHeading="Product"
  i18n-navAnchorHeading="@@products.nav.product.heading"
  [navAnchorHidden]="hasContent() === false"
  class="no-bg"
>
  <ideal-product-specifications #content [productId]="id()"></ideal-product-specifications>
</ideal-product-section>
